import { createFileRoute } from "@tanstack/react-router";

import { MorrowAgentWindowPage } from "../components/workspace/MorrowAgentWindowPage";

export const Route = createFileRoute("/agents/$agentId")({
  component: MorrowAgentWindowPage,
});
